import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import './style.css';
 let DemandPeak=(props)=> { 
   return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  DemandPeak ScoreCard
  </h4>
        <br></br>
        <h6 id="h6">
  
  Marketing scorecard is relatively simple, it measures experience of the team in sales and marketing
  
  </h6>
        <div id='divL'>
          <table id='tableAll'>
            <thead>
              <tr>
                <th scope="col">Steady Demand</th>
                <th scope="col">Select One Option</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Steady Demand">Team has no priour marketing experenince</td>
                <td data-label="Select One Option">
                  <input type="radio" name='same'></input>
                </td>
              </tr>
              <tr>
                <td data-label="Steady Demand">Team has prior marketing experenince but it fails</td>
                <td data-label="Select One Option">
                  <input type="radio" name='same'></input>
                </td>
              </tr>
              <tr>
                <td data-label="Steady Demand">Total</td>
                <td data-label="Select One Option">
                  <input type='text' placeholder="Locked" id="lockedInput"></input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/pmcm')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/result')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default DemandPeak;